import { SharedFilterNamesEnum } from '../responding-dashboards-filter-models';

export enum TimeRangeBucketFormat {
  'DAY' = 'DAY',
  'WEEK' = 'WEEK',
  'MONTH' = 'MONTH',
}

export interface ReviewInsightsFilterInterface {
  storeCode: string[];
  businessName: string[];
  city: string[];
  countryCodes: string[];
  fromDate: string;
  toDate: string;
  days: number;
  bucketFormat?: TimeRangeBucketFormat;
}

export const ImplementedInsightsFilterNames: SharedFilterNamesEnum[] = [
  SharedFilterNamesEnum.BUSINESS_NAME,
  SharedFilterNamesEnum.COUNTRY_CODES,
  // ADD MORE
];
